__turbopack_context__.v({
  "banner": "FileDropzone-module__pUsF1W__banner",
  "description": "FileDropzone-module__pUsF1W__description",
  "dragging": "FileDropzone-module__pUsF1W__dragging",
  "hint": "FileDropzone-module__pUsF1W__hint",
  "icon": "FileDropzone-module__pUsF1W__icon",
  "iconIn": "FileDropzone-module__pUsF1W__iconIn",
  "link": "FileDropzone-module__pUsF1W__link",
  "root": "FileDropzone-module__pUsF1W__root",
  "spin": "FileDropzone-module__pUsF1W__spin",
});
